export const initialDaysOfWeek ={
    "monday": [
      {
        "from_time": "",
        "to_time": ""
      }
    ],
    "tuesday": [
      {
        "from_time": "",
        "to_time": ""
      }
    ],
    "wednesday": [
      {
        "from_time": "",
        "to_time": ""
      }
    ],
    "thursday": [
      {
        "from_time": "",
        "to_time": ""
      }
    ],
    "friday": [
      {
        "from_time": "",
        "to_time": ""
      }
    ],
    "saturday": [
      {
        "from_time": "",
        "to_time": ""
      }
    ],
    "sunday": [
      {
        "from_time": "",
        "to_time": ""
      }
    ]
  }